<template>
  <div
    :id="modalId"
    class="ui modal">
    <div class="header">
      {{ $t('shortNameDisplay', { shortName: content.data.shortName }) }}
    </div>
    <div
      class="scrolling content"
      style="padding: 1.5rem;">
      <form
        :id="formId"
        class="ui form">
        <input-group
          :key="inputGroupKey"
          :value="selectedDraftContent"
          :data="modalForm"
          v-model="selectedDraftContent"/>
      </form>
    </div>
    <div class="actions">
      <div
        class="ui left floated button"
        @click="closeModal">
        {{ $t('cancel') }}
      </div>
      <div
        class="ui button"
        @click="saveDraftContent">
        {{ $t('save') }}
      </div>
    </div>
  </div>
</template>

<script>
import InputGroup from '../InputGroup'
import { DraftUserAction, DraftUserLesson } from '../../structs/structs'

const structs = new Map(
  [
    ['draft-action', DraftUserAction],
    ['draft-lesson', DraftUserLesson]
  ]
)

export default {
  name: 'EditContentModal',
  components: { InputGroup },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      modalForm: null,
      selectedDraftContent: null
    }
  },
  computed: {
    itemType () { return 'content' },
    formId () { return `edit-content-form-${this._uid}` },
    modalId () { return `edit-content-modal-${this._uid}` },
    // NOTE: `InputGroup` is keyed in order to trigger re-render from newly selected content
    inputGroupKey () { return `content-${this.content.data.id}` }
  },
  watch: {
    content: {
      handler (newValue) {
        if (newValue) {
          this.selectedDraftContent = new (structs.get(`draft-${this.itemType}`))(newValue || {})
        }
      },
      deep: true
    }
  },
  methods: {
    saveDraftContent () {
      this.initializeFormValidator()
      this.validateForm()

      const isValid = this.formIsValid()

      if (isValid) {
        this.updateContent()
        this.closeModal()
      }
    },
    updateContent () {
      this.$emit('update-selected-draft-content', this.selectedDraftContent)
    },
    closeModal () {
      $('#' + this.formId)
        .form('reset')

      $('#' + this.modalId)
        .modal('reset')
        .modal('hide')
    },
    validateForm () {
      return $('#' + this.formId).form('validate form')
    },
    formIsValid () {
      return $('#' + this.formId).form('is valid')
    }
  },
  beforeDestroy () {
    let modal = $('#' + this.modalId)
    if (modal !== null) {
      modal.remove()
    }
  }
}
</script>

<style scoped>

</style>
